import { hasAccess } from 'utils'
import { userRoles } from '../../constants'

// JWTs carry RAW DB roles (the backend role hierarchy is not expanded
// client-side), so every check must list the inheriting roles explicitly:
// a pure ROLE_SUPER_ADMIN token must pass all admin gates.
export const isAdmin = user => hasAccess(user.roles, [userRoles.ADMIN, userRoles.SUPER_ADMIN]);
export const isSuperAdmin = user => hasAccess(user.roles, [userRoles.SUPER_ADMIN]);
export const isTrainer = user => hasAccess(user.roles, [userRoles.TRAINER]);
// ROLE_MAIN_SECRETARY inherits ROLE_SECRETARY on the backend (security.yaml
// role_hierarchy), so a main secretary passes every secretary gate too.
export const isSecretary = user => hasAccess(user.roles, [userRoles.SECRETARY, userRoles.MAIN_SECRETARY]);
export const isMainSecretary = user => hasAccess(user.roles, [userRoles.MAIN_SECRETARY]);

// THE SHOOTING SECRETARY (27 Oct 2026): the competitions whose shooting this
// user keeps, from /api/me. Shooting ONLY on a competition — the protocol, the
// «Стрільба» tab and its «УВАГА», nothing else — when they are neither an
// admin nor a chief secretary; the backend refuses the rest either way.
export const isShootingSecretaryOf = (user, competitionId) => Boolean(
  user && competitionId && Array.isArray(user.shootingCompetitionIds)
    && user.shootingCompetitionIds.includes(competitionId)
);
export const isShootingOnlyOn = (user, competitionId) => Boolean(user)
  && !isAdmin(user) && !isMainSecretary(user) && isShootingSecretaryOf(user, competitionId);
